export const scrollTo = (pos = 0) => {
    window.scrollTo({
        top: pos,
        behavior: "smooth"
    })
}

/**
 * @param e {Element} Use target value from Select to redirect
 */
export const selectRedirect = (e) => window.location = e.target.value;

/**
 * @param e {Element} Use data-target for clear input
 */
export const handleClearInput = (e) => {
    const {target} = e.target.dataset;
    const clearObjects = document.querySelectorAll(`[data-action-clear="${target}"]`);

    for (const clearObject of clearObjects) {
        clearObject.value = null;
    }
}

/**
 * @param e {Element} Use data-target for toggle password field type
 */
export const togglePassword = (e) => {
    const {target} = e.target.dataset;
    const togglePasswordObjects = document.querySelectorAll(`[data-action-toggle-password="${target}"]`);

    for (const togglePasswordObject of togglePasswordObjects) {
        const {type} = togglePasswordObject;
        const {target} = e;
        togglePasswordObject.type = type === 'password' ? 'text' : 'password';
        target.classList.add(type === 'password' ? 'icon-eye' : 'icon-eye-blocked');
        target.classList.remove(type === 'password' ? 'icon-eye-blocked' : 'icon-eye');
    }
}

/**
 * @param e {Element} Use target for sync text from input type range
 */
export const inputRangeSync = (e) => {
    const {target} = e;
    const field = target.closest('.js-input-range').querySelector('.js-range-value');
    const {unit} = field.dataset;
    field.innerHTML = target.value + unit;
}

/**
 * @param e {Element} Use target for check inputs inside container
 */
export const toggleCheckboxList = (e) => {
    const {target} = e;
    const container = target.closest('.js-checkbox-list');
    const checkboxes = container.querySelectorAll('[type="checkbox"]');

    for (const checkbox of checkboxes) {
        checkbox.checked = target.classList.contains('js-checkbox-list-all')
    }
}
